import { render, staticRenderFns } from "./VodacomTransactionDetail.vue?vue&type=template&id=6e91ec15&scoped=true"
import script from "./VodacomTransactionDetail.vue?vue&type=script&lang=js"
export * from "./VodacomTransactionDetail.vue?vue&type=script&lang=js"
import style0 from "./VodacomTransactionDetail.vue?vue&type=style&index=0&id=6e91ec15&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e91ec15",
  null
  
)

export default component.exports